const JobTypes = {
  MD_CONFIGURATION_DEPLOYMENT: "mdConfigurationDeployment",
  CRM_CONFIGURATION_DEPLOYMENT: "crmConfigurationDeployment"
} as const;

const ALL = Object.values(JobTypes);

export default { ...JobTypes, ALL };
